import {
  ArrowDown,
  ArrowUpRight,
  BookOpenCheck,
  ExternalLink,
  MessageCircleMore,
  Sparkles,
  UsersRound,
} from "lucide-react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { assetUrl, homeUrl } from "@/lib/assets";

const resources = [
  {
    number: "01",
    title: "Compromiso Bíblico",
    originalName: "Bible Engagement Project",
    description:
      "Currículo gratuito de discipulado para preescolares, niños, jóvenes y adultos. Todas las edades avanzan con el mismo alcance y secuencia para facilitar conversaciones bíblicas en la iglesia y el hogar.",
    features: ["Disponible en español", "Biblioteca para todas las edades", "Devocionales familiares"],
    image: assetUrl("bible-engagement-project-all-ages.png"),
    alt: "Recursos del Proyecto Compromiso Bíblico para diferentes grupos de edad",
    href: "https://bibleengagementproject.com/es-ES",
    external: true,
    linkLabel: "Explorar el proyecto",
    icon: BookOpenCheck,
  },
  {
    number: "02",
    title: "Grupos Alpha",
    originalName: "Conversaciones sobre vida y fe",
    description:
      "Una serie de encuentros abiertos y acogedores donde las personas comparten, escuchan una charla y conversan honestamente sobre la vida, la fe y el sentido, sin presión ni juicios.",
    features: ["Gratuito y abierto para todos", "Recursos y capacitación", "Presencial u online"],
    image: assetUrl("alpha-groups-conversation.webp"),
    alt: "Grupo Alpha conversando alrededor de una mesa",
    href: "https://pruebaalpha.org/",
    external: true,
    linkLabel: "Conocer Alpha",
    icon: MessageCircleMore,
  },
  {
    number: "03",
    title: "Biblia de Discipulado",
    originalName: "Biblia de estudio para el discipulado",
    description:
      "Una herramienta de estudio con notas y contenidos orientados a formar discípulos centrados en Cristo, fortalecer iglesias discipuladoras y vivir la Palabra en el contexto cotidiano.",
    features: ["Estudios y notas de formación", "Discipulado transformacional", "Enfoque en iglesia saludable"],
    image: assetUrl("biblia-estudio-discipulado.png"),
    alt: "Biblia de Estudio para el Discipulado",
    href: homeUrl("contacto/?tema=recursos#contacto-formulario"),
    external: false,
    linkLabel: "Solicitar información",
    icon: UsersRound,
  },
];

export default function ResourcesPage() {
  return (
    <div className="acad-react-page acad-resources-page">
      <Header />

      <main>
        <section className="acad-resources-hero" data-nav="dark">
          <span className="acad-resources-grid" aria-hidden="true" />
          <span className="acad-resources-symbol" aria-hidden="true">R</span>

          <div className="acad-resources-shell acad-resources-hero-inner">
            <div className="acad-resources-hero-top">
              <span><Sparkles aria-hidden="true" /> Recursos ACAD</span>
              <small>Formar · Equipar · Multiplicar</small>
            </div>

            <div className="acad-resources-hero-copy">
              <span className="acad-resources-eyebrow">Herramientas para la iglesia</span>
              <h1>
                Recursos que
                <span>activan el llamado.</span>
              </h1>
              <p>
                Contenido seleccionado para fortalecer el discipulado bíblico, crear espacios de
                conversación y equipar a líderes que sirven a cada generación.
              </p>
            </div>

            <a className="acad-resources-scroll" href="#biblioteca">
              Explorar la selección <ArrowDown aria-hidden="true" />
            </a>
          </div>
        </section>

        <section className="acad-resources-intro">
          <div className="acad-resources-shell acad-resources-intro-grid">
            <span className="acad-resources-eyebrow acad-resources-eyebrow--dark">Biblioteca recomendada</span>
            <div>
              <h2>Tres recursos.<br />Una misión de formación.</h2>
              <p>
                Propuestas prácticas para conectar la Biblia con la vida, acompañar preguntas
                honestas y desarrollar comunidades de fe saludables.
              </p>
            </div>
          </div>
        </section>

        <section className="acad-resources-library" id="biblioteca">
          <div className="acad-resources-shell acad-resources-list">
            {resources.map((resource, index) => {
              const Icon = resource.icon;

              return (
                <article className={`acad-resource-card ${index % 2 ? "acad-resource-card--reverse" : ""}`} key={resource.number}>
                  <div className="acad-resource-media">
                    <img src={resource.image} alt={resource.alt} loading="lazy" decoding="async" />
                    <span>{resource.number}</span>
                  </div>

                  <div className="acad-resource-copy">
                    <div className="acad-resource-icon"><Icon aria-hidden="true" /></div>
                    <small>{resource.originalName}</small>
                    <h3>{resource.title}</h3>
                    <p>{resource.description}</p>

                    <div className="acad-resource-features">
                      {resource.features.map((feature) => <span key={feature}>{feature}</span>)}
                    </div>

                    <a
                      href={resource.href}
                      target={resource.external ? "_blank" : undefined}
                      rel={resource.external ? "noreferrer" : undefined}
                    >
                      {resource.linkLabel}
                      {resource.external ? <ExternalLink aria-hidden="true" /> : <ArrowUpRight aria-hidden="true" />}
                    </a>
                  </div>
                </article>
              );
            })}
          </div>
        </section>

        <section className="acad-resources-final" data-nav="dark">
          <div className="acad-resources-shell acad-resources-final-inner">
            <BookOpenCheck aria-hidden="true" />
            <div>
              <span className="acad-resources-eyebrow">Aprender para compartir</span>
              <h2>La formación se multiplica cuando se convierte en práctica.</h2>
            </div>
            <a href={homeUrl("contacto/?tema=recursos#contacto-formulario")}>Consultar recursos <ArrowUpRight aria-hidden="true" /></a>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
